import React from 'react';
const TextField = ({ field, }) => {
    const Tag = (field.model.htmlTag || 'p');
    return React.createElement(Tag, { className: field.model.cssClass }, field.model.text);
};
export default TextField;
